const SITE_URL = "https://www.itoinsuranceagency.com";
const SITE_NAME = "I.T.O. Insurance Agency";
const DEFAULT_OG_IMAGE = "/og-image.png";
const AGENCY_ID = `${SITE_URL}/#agency`;
const FOUNDER_ID = `${SITE_URL}/#jessica-q-tcheng`;

const seoByPath = {
  "/": {
    title: "I.T.O. Insurance Agency | Medicare & Covered California",
    description:
      "Licensed agents in Garden Grove, CA helping people enroll in Medicare, Covered California, and individual & family health insurance at no extra cost.",
  },
  "/medicare-plans": {
    title: "Medicare Plans | I.T.O. Insurance Agency",
    description:
      "Compare Medicare Advantage, Medigap, and Part D options with a licensed agent. Free guidance for seniors in Southern California.",
  },
  "/individual-family-plans": {
    title: "Individual & Family Plans | Covered California",
    description:
      "Shop Covered California and off-exchange individual & family health insurance plans with no-cost licensed help.",
  },
  "/health-insurance-101": {
    title: "Health Insurance 101 | I.T.O. Insurance Agency",
    description:
      "Learn health insurance basics—premiums, deductibles, copays, and how to choose a plan that fits your needs.",
  },
  "/employer-sponsored-plans": {
    title: "Employer-Sponsored Plans | I.T.O. Insurance Agency",
    description:
      "Group health insurance guidance for employers and employees. Understand eligibility, contributions, and plan options.",
  },
  "/final-expense-plans": {
    title: "Final Expense Plans | I.T.O. Insurance Agency",
    description:
      "Affordable final expense and burial coverage options to help protect loved ones from unexpected costs.",
  },
  "/meet-the-founder": {
    title: "Meet the Founder | Jessica Q Tcheng",
    description:
      "Meet Jessica Q Tcheng, licensed insurance agent and founder of I.T.O. Insurance Agency in Garden Grove, California.",
  },
  "/meet-the-agents": {
    title: "Meet the Agents | I.T.O. Insurance Agency",
    description:
      "Meet the licensed agents and team at I.T.O. Insurance Agency who help clients with Medicare and health coverage.",
  },
  "/testimonials": {
    title: "Client Testimonials | I.T.O. Insurance Agency",
    description:
      "Read reviews from Medicare and health insurance clients who worked with I.T.O. Insurance Agency.",
  },
  "/faq": {
    title: "FAQ | Medicare & Covered California",
    description:
      "Answers to common questions about Medicare, Covered California, enrollment periods, quotes, and plan eligibility.",
  },
  "/contact-us": {
    title: "Contact Us | I.T.O. Insurance Agency",
    description:
      "Schedule a free consultation. Call (949) 317-2220 ext. 2 or visit us at 12818 Brookhurst Street, Garden Grove, CA.",
  },
  "/become-an-agent": {
    title: "Become an Agent | I.T.O. Insurance Agency",
    description:
      "Start a flexible career in health insurance. Contact I.T.O. Insurance Agency to learn about becoming an independent agent.",
  },
};

const crumbName = {
  "/": "Home",
  "/medicare-plans": "Medicare Plans",
  "/individual-family-plans": "Individual & Family Plans",
  "/health-insurance-101": "Health Insurance 101",
  "/employer-sponsored-plans": "Employer-Sponsored Plans",
  "/final-expense-plans": "Final Expense Plans",
  "/meet-the-founder": "Meet the Founder",
  "/meet-the-agents": "Meet the Agents",
  "/testimonials": "Testimonials",
  "/faq": "FAQ",
  "/contact-us": "Contact Us",
  "/become-an-agent": "Become an Agent",
};

const city = (name, region) => ({
  "@type": "City",
  name,
  containedInPlace: { "@type": "State", name: region },
});

const services = [
  ["Medicare Plans", "/medicare-plans"],
  ["Covered California and Individual & Family Plans", "/individual-family-plans"],
  ["Employer-Sponsored Plans", "/employer-sponsored-plans"],
  ["Final Expense Plans", "/final-expense-plans"],
];

const reviews = [
  ["Dr. Harley, DaWanda & Tabitha H.", "Santa Ana, CA", "Jessica comes very highly recommended by the Howard family. She is a very hard and diligent worker and went beyond our expectations for our insurance needs. In this day and age where dependable people are at an all time low, with Jessica you will not be disappointed!"],
  ["Sharin B.", "Hawthorne, CA", "Jessica has helped me with my insurance and doctor selection so many times, I cannot count. She is caring and gets back to me immediately. I always feel she cares about me personally and remembers my health issues. She has spent endless time helping me. She is knowledgeable about different insurance carriers and doctors. She will do whatever it takes to get you the best possible care. I highly recommend Jessica for all your insurance needs."],
  ["Richard E.", "Meridian, TX", "Just cares absolutely in amazing young girl she is answered every question iPad never made me feel the hurried or pressured he help me find exactly the plan I was looking for and I would definitely recommend her to everyone I know."],
  ["Thomas W.", "Phoenix, AZ", "I have had the greatest pleasure of working with Jessica for several years. She has proven herself as a very dependable, hard and diligent worker. In this day and age dependable people seem to be at an all-time low,. She has went beyond my expectations to meet my insurance needs. and works very hard to help me find the insurance policy that fit my unique situation. Jessica has always been extremely helpful and willing to get me everything I am entitled to. She is absolutely an amazing young lady who provided correct answers to every question, She would even check and make sure, when necessary. Jessica never has made me feel hurried or pressured when she helps me and found the exact best plan for me. I highly recommend her to everyone. With Jessica you will not be disappointed!"],
  ["Terrance G & Khiem P.", "Anaheim, CA", "We have used Jessica for about 5 yrs, retirement medical, always addresses our concerns right away, highly recommended"],
  ["Judith B.", "Phoenix, AZ", "Jessica is extremely helpful and is willing do get you everything you are entitled to.. She is extremely pleasant and knowledgeable! I enjoy working with her."],
  ["Farhan K.", "Cypress, CA", "She helped us out greatly with our insurance plan, can’t recommend her enough!"],
  ["Shig M.", "Orange, CA", "If you need a helping hand she is there for you. If you need to learn what’s going on, she will educate you. Whatever the situation, she will find what works best for you with all of her willpower. If you take a look on her insurance agency webpage, it proves her dedication, knowledge, and diligence."],
  ["Eva Lopez", "Long Beach, CA", "I'm Eva Lopez I recommended Jessica she is very especial to work with insurance thank you for your help"],
  ["Devin P.", "Apache Junction, AZ", "I was so overwhelmed with everything related to Medicare when I turned 65 and ready to retire. I was inundated with mail from so many different insurance companies, phone calls and messages every day of the week and people coming to my home knocking on my door. A good friend of mine suggested I contact Jessica Tcheng for help. Jessica helped me every step of the way. She spent a lot of time with me on the phone explaining everything in detail and the options available. She contacted my doctors’ offices and found out what plans they accepted. She sent me info on the plans she thought were the best for me to review and help with my choices. Jessica made the whole process so easy for me to understand and complete. I just can’t say enough good things about her!! If you have any issues, problems, or questions about Medicare, I suggest you contact Jessica Q Tcheng @ www.itoinsuranceagency.com, Phone: (949) 394-7738, Fax: (949) 301-9611 She will help you at no cost!!"],
  ["Esther & Ramon A.", "Santa Clarita, CA", "She's very helpful, attentive and she treats me like she's helping a family member."],
  ["Letty J.", "Cerritos, CA", "Jessica Tcheng is a wonderful and efficient agent. Every time its open enrollment and I need for her to check on new plans that can save me money ,she is quick to respond with different plans that may benefit my families needs. I highly recommend her to all my friends and family."],
  ["Larry S.", "Phoenix, AZ", "I must say Jessica Is very swift and a tentative Towards her clients needs. I have been a client now going on 7 years And I have to say she has always had my best interest in mind regarding my health care needs and has gone out of her scope to assist me, I would definitely recommend her for those of you that have insurance questions and/or needs"],
  ["Chris F.", "Peoria, AZ", "I have had the greatest pleasure working with Jessica. She understands her clients needs and works very hard to help them find the insurance policy that fits their unique situation."],
  ["Vince K.", "Bullhead City, AZ", "Medicare??? Who can understand it. I read all the literature that came in the mail. It was time for me to make some choices. Lucky for me I met Jessica Tcheng. Her knowledge and patient way of explaining made it easy for me. I had a great outcome. When I moved out of state Jessica helped me with a smooth transition with Insurance. If you are needing Insurance, my suggestion is to talk to Jessica. She has always been available If I had any questions."],
  ["Paul D.", "Westminster, CA", "Jessica helped me out with some problems I had even after my new insurance started. She is exceptional as an agent."],
  ["Jane G.", "Phoenix, AZ", "Jessica Tcheng did a very thorough job in researching a new health insurance plan to fit my particular needs. She also suggested a new Primary Care provider that I have been very happy with. What a relief to have her expertise in making these important decisions. Her willingness to \"go the extra mile\" has been a true blessing!"],
  ["William B.", "Long Beach, CA", "ITO Insurance Agency is awesome! Also Jessica Tcheng is awesome! If you really want a good insurance plan better get with Jessica. Someone who really loves what she dose, her job. And she really love helping people, especially us seniors. I tell you the truth, there's been a couple of times I've gotten so frustrated trying to distinguish which insurance plan is a good insurance plan from going through quite a few? So I call Jessica for help, and I get help and no more frustration! She finds me a really good insurance plan. William Beck US Army Disabled Veteran."],
];

const faq = [
  [
    "How do I get a quote?",
    "To run a health insurance quote, the following information is needed: Date Of Birth (of every member applying for coverage); Permanent Home Zip Code; Projected Adjusted Gross Income for 2021 (if applying for premium assistance through Covered CA). Email us at info@itoinsuranceagency.com",
  ],
  [
    "What is Medicare vs. Medicaid?",
    "Medicare is health insurance coverage for those 65 and over (or those under 65 receiving SSDI.) Medicaid (as known as Medi-Cal in CA) is for those who are considered low income by each states' individual qualifications.",
  ],
  [
    "When can I enroll?",
    "Every year during the Annual Enrollment Period (AEP) that runs: Individual & Families (off-exchange)/Covered CA Plans(on-exchange) - every year between November to January; Medicare Advantage & Prescription Drug Plans - every year between October 15th-December 7th; Employer-Sponsored Plans - dependent upon each individual employer; Medicaid/Medi-Cal - any time of the year; Medicare Supplements - any time of the year but must be approved based on past medical records/conditions. Special Enrollment Period (SEP). Under Individual & Families (off-exchange)/Covered CA Plans(on-exchange), SEP is available the rest of the year by qualifying for a special life event, such as: Having a baby; Getting married; Getting divorced; Moving from plan service area; Losing employer coverage involuntarily; Turning 26; Etc. Under Medicare Advantage & Prescription Drug Plans, SEP includes: Turning 65 or qualifying for Medicare; Qualifying for Prescription Extra Help, a Medicare Savings Program, or Medicaid/Medi-Cal; Moving from plan service area; Retiring from employer coverage; Medicare Advantage Open Enrollment Period (OEP)- from January through March; Eligible for Chronic Plan based on conditions such as diabetes, heart/lung disease, etc.",
  ],
  [
    "Do I qualify?",
    "Since the implementation of the Affordable Cares Act (ACA) there are no pre-existing conditions for the following: Individual & Families/Covered CA Plans; Employer-Sponsored Plans; Medicaid/Medi-Cal. Under Medicare, the following also do not have pre-existing conditions: Medicare Advantages; Prescription Drug Plans. Except during the Initial Enrollment Period for those newly eligible for Medicare, Medicare Supplements/Medigap plans applications do go under review and require approval based on the applicant's medical records and history.",
  ],
  [
    "Is there still a penalty for not having health coverage?",
    'At the federal level, the health insurance penalty no longer applies. But the state of California (alongside a couple of other states) chose to continue to implement the penalty to its state residents. "Starting in 2020, California residents must either: Have qualifying health insurance coverage, or; Pay a penalty when filing a state tax return, or; Get an exemption from the requirement to have coverage. The penalty for not having coverage the entire year will be at least $750 per adult and $375 per dependent child under 18 in the household when you file your 2020 state income tax return in 2021. A family of four that goes uninsured for the whole year would face a penalty of at least $2,250. The penalty will be applied by the California Franchise Tax Board. For information about the penalty, including the amount your family could owe for not having coverage, visit the Franchise Tax Board’s website and use their Penalty Estimator Tool." Click here for the original resource.',
  ],
  [
    "What is excluded from coverage on a medical health insurance plan?",
    "Other than for minors under 18, health insurance plans only cover medical services such as doctor/specialist visits, preventative services, x-rays, surgery, hospital, ambulance, etc. Dental, vision, acupuncture, chiropractic care, etc. are not covered benefits in most cases. Additional stand-alone plans must be added to cover these benefits.",
  ],
];

const canonicalFor = (pathname) =>
  pathname === "/" ? `${SITE_URL}/` : `${SITE_URL}${pathname}`;

const agencyNode = () => ({
  "@type": ["InsuranceAgency", "LocalBusiness"],
  "@id": AGENCY_ID,
  name: SITE_NAME,
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}/jessica_ito.png`,
  image: `${SITE_URL}/og-image.png`,
  description:
    "Licensed agents helping individuals, families, and seniors enroll in Medicare and Covered California plans. Call (949) 317-2220 ext. 2.",
  telephone: "+1-949-317-2220",
  email: "info@itoinsuranceagency.com",
  faxNumber: "+1-949-301-9611",
  priceRange: "Free consultations",
  address: {
    "@type": "PostalAddress",
    streetAddress: "12818 Brookhurst Street",
    addressLocality: "Garden Grove",
    addressRegion: "CA",
    postalCode: "92840",
    addressCountry: "US",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 33.7766914,
    longitude: -117.956398,
  },
  hasMap:
    "https://www.google.com/maps/search/?api=1&query=12818+Brookhurst+Street%2C+Garden+Grove%2C+CA+92840",
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+1-949-317-2220",
    contactType: "customer service",
    areaServed: "US",
    availableLanguage: "English",
    description: "(949) 317-2220 ext. 2",
  },
  founder: { "@id": FOUNDER_ID },
  areaServed: [
    { "@type": "AdministrativeArea", name: "Orange County" },
    city("Garden Grove", "California"),
    city("Huntington Beach", "California"),
    city("Santa Ana", "California"),
    city("Hawthorne", "California"),
    city("Anaheim", "California"),
    city("Cypress", "California"),
    city("Orange", "California"),
    city("Long Beach", "California"),
    city("Santa Clarita", "California"),
    city("Cerritos", "California"),
    city("Westminster", "California"),
    city("Phoenix", "Arizona"),
    city("Apache Junction", "Arizona"),
    city("Peoria", "Arizona"),
    city("Bullhead City", "Arizona"),
    city("Meridian", "Texas"),
  ],
  makesOffer: {
    "@type": "Offer",
    name: "No-cost consultation",
    price: "0",
    priceCurrency: "USD",
  },
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Insurance plans",
    itemListElement: services.map(([name, path]) => ({
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name,
        url: `${SITE_URL}${path}`,
        provider: { "@id": AGENCY_ID },
      },
    })),
  },
  sameAs: [
    "https://www.instagram.com/i.t.o.insuranceagency/",
    "https://www.facebook.com/i.t.o.insuranceagency/",
    "https://www.yelp.com/biz/jessica-q-tcheng-ito-insurance-agency-garden-grove",
  ],
});

const founderNode = () => ({
  "@type": "Person",
  "@id": FOUNDER_ID,
  name: "Jessica Q Tcheng",
  jobTitle: "Founder/Licensed Agent",
  url: `${SITE_URL}/meet-the-founder`,
  worksFor: { "@id": AGENCY_ID },
  description:
    "Jessica has been licensed since 2010. With over 10 years of experience within the insurance industry, her clients have confidence in her knowledge & expertise. She is able to relate to each client’s unique needs so feel free to reach out to her if you are looking for a full, comprehensive explanation of your options.",
});

const breadcrumbNode = (pathname) => {
  const items = [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: `${SITE_URL}/`,
    },
  ];
  if (pathname !== "/") {
    items.push({
      "@type": "ListItem",
      position: 2,
      name: crumbName[pathname] || seoByPath[pathname].title,
      item: canonicalFor(pathname),
    });
  }
  return {
    "@type": "BreadcrumbList",
    "@id": `${canonicalFor(pathname)}#breadcrumb`,
    itemListElement: items,
  };
};

const buildPageGraph = (pathname) => {
  const path = seoByPath[pathname] ? pathname : "/";
  const graph = [agencyNode(), founderNode(), breadcrumbNode(path)];

  if (path === "/faq") {
    graph.push({
      "@type": "FAQPage",
      "@id": `${SITE_URL}/faq#faq`,
      mainEntity: faq.map(([question, answer]) => ({
        "@type": "Question",
        name: question,
        acceptedAnswer: {
          "@type": "Answer",
          text: answer,
        },
      })),
    });
  }

  if (path === "/testimonials") {
    reviews.forEach(([name, location, body], index) => {
      graph.push({
        "@type": "Review",
        "@id": `${SITE_URL}/testimonials#review-${index + 1}`,
        author: { "@type": "Person", name },
        itemReviewed: { "@id": AGENCY_ID },
        reviewBody: body,
        name: `${name} (${location})`,
      });
    });
  }

  return {
    "@context": "https://schema.org",
    "@graph": graph,
  };
};

module.exports = {
  SITE_URL,
  SITE_NAME,
  DEFAULT_OG_IMAGE,
  seoByPath,
  crumbName,
  canonicalFor,
  buildPageGraph,
};
